var productCardMarkup =
    `<div class="swym-wishlist-grid">
		{{#products}} 
	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"/></svg></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
		<div class="swym-title swym-title-1">
			{{dt}}
		</div></button>
		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{pr}} {{cu}}
			</div>
        </div>
		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
		</button>
    </a> 
       {{/products}}
	</div>`;

function getVariantInfo(variants) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
            variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch (err) {
        return variants;
    }
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
    swat.fetch(function(products) {
        var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        var formattedWishlistedProducts = products.map(function(p) {
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            return p;
        });
        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
            products: formattedWishlistedProducts
        });

        if(wishlistContentsContainer){
            if (products.length >= 1) {
                wishlistContentsContainer.innerHTML = productCardsMarkup;
            } else {
                wishlistContentsContainer.innerHTML =
                    "<div class='swym-wishlist-grid' style='justify-content: center'>" +
                        "<div class='swym-wishlist-item swym-is-anchor'>" +
                        "<div class='swym-description'>Add to your Wishlist by selecting the heart icon. Here you can save items edit selections and add favourites to your Shopping Bag.</div>" +
                        "<div class='symb-button'><a href='/collections/shop-all'>Browse Our Store</a></div>"
                        "</div>" +
                    "</div>";
            }
            attachClickListeners();
        } else{
            console.log("Container not found, Wishlist Page element not found");
        }

    });
}

function onAddToCartClick(e) {
    e.preventDefault();
    var productId = e.currentTarget.getAttribute("data-product-id");
    var variantId = e.currentTarget.getAttribute("data-variant-id");
    var du = e.target.getAttribute("data-product-url");
    e.target.innerHTML = "Adding..";
    window._swat.replayAddToCart({
        empi: productId,
        du: du
    }, variantId, function(c) {
        e.target.innerHTML = "Added to Cart";
        e.target.setAttribute("data-state-cart", "swym-added");
        console.log("Successfully added product to cart.", c);
    }, function(e) {
        console.log(e);
    });
    window.location = theme.routes.cart_url;
}

function attachClickListeners() {
    var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
    var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
    //   Add to cart Btns
    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
    }
    //   Remove Buttons
    for (var k = 0; k < removeBtns.length; k++) {
        removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
    }
    console.log("Events attached!");
}

function onRemoveBtnClick(e) {
    e.preventDefault();
    var epi = +e.currentTarget.getAttribute("data-variant-id");
    var empi = +e.currentTarget.getAttribute("data-product-id");
    window._swat.fetch(function(products) {
        products.forEach(function(product) {
            if (epi && empi && product.epi == epi && product.empi == empi) {
                window._swat.removeFromWishList(product, function() {
                    if (!window.SwymCallbacks) {
                        window.SwymCallbacks = [];
                    }
                    window.SwymCallbacks.push(swymRenderWishlist);
                });
            }
        });
    })
}